import { useSearchParams, Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const orderId = params.get('order_id');
  return (
    <div className="container-x py-16 md:py-24" data-testid="payment-cancel">
      <div className="max-w-lg mx-auto text-center">
        <XCircle size={40} className="mx-auto text-neutral-400" />
        <p className="eyebrow mt-6">Checkout cancelled</p>
        <h1 className="h-display text-3xl md:text-4xl mt-2">No charge made.</h1>
        <p className="sans text-sm text-neutral-500 mt-3">
          You closed the payment window before finishing. Your order is untouched — you can try again anytime.
        </p>
        {orderId && (
          <Link to={`/orders/${orderId}`} className="btn-primary inline-flex mt-6" data-testid="payment-cancel-order-link">
            Back to order
          </Link>
        )}
      </div>
    </div>
  );
}
